<template>
    <div class="components-container">
        <div class="iframe-container">
            <iframe :src="ifameSrc" id="biz-frame" frameborder="0" width="100%" height="820px" scrolling="auto"></iframe>
        </div>
    </div>
</template>

<script>
import {globalConfig} from "static/config"

export default {
    data() {
        return {
            ifameSrc: '',
        }
    },
    created() {
        this.request();
    },
    methods: {
        request() {
            if (globalConfig.evaVersion && localStorage.getItem('user') === 'admin') {
                this.$router.push({path: '/index'});
            } else {
                if (this.isMobile()) {
                    this.$router.push({path: '/m/home'});
                } else {
                    this.$router.push({path: '/homePage'});
                }
            }
            // 需要重新刷新页面 请求 路由表 和 用户信息
            location.reload();
        },
        isMobile() {
            return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        },
    }
}
</script>



// WEBPACK FOOTER //
// iframe.vue?0f3f1f2c